import { render, staticRenderFns } from "./FlightItemApp.vue?vue&type=template&id=6b6e8f16&scoped=true"
import script from "./FlightItemApp.vue?vue&type=script&lang=js"
export * from "./FlightItemApp.vue?vue&type=script&lang=js"
import style0 from "./FlightItemApp.vue?vue&type=style&index=0&id=6b6e8f16&prod&scoped=true&lang=css"
import style1 from "./FlightItemApp.vue?vue&type=style&index=1&id=6b6e8f16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6e8f16",
  null
  
)

export default component.exports